<template>
    
    <div class="inProduct_list" >
          <template  v-if="productList && productList.length>0 && bannerUrl">  
          <swiper :options="swiperOptionPlist" ref="proSwiper">
            <swiper-slide class="inProduct_item headAuto">
                <BannerIn :bannerUrl="bannerUrl" :positionInfo="positionInfo" />
                <NavIn :inNavInfo="inNavInfo"  />
            </swiper-slide>
                    
                <swiper-slide class="inProduct_item" v-for="item in productList" :key="item.id">
                    <section class="inProductBox">
                        <div class="wrapper">
                            <div class="inProductItem">

                                <router-link to="#" class="inProductItem_img">
                                    <img :src="$root.$TEMP_URL+item.ico"  @click="changeTanStatus(true,item.contentid)" />
                                    <div class="inProductItem_detail">
                                      <div class="title">{{item.title}}</div>
                                      <div class="line"></div>
                                      <div class="clear"></div>
                                      <!-- <div class="cen" v-html="item.content">
 
                                      </div> -->
                                      
                                    </div>
                                    <div class="inProductItem_btnBox">
                                        <div class="inProductItem_btnLeft">
                                            <img src="./images/more_def.png" />
                                        </div>
                                        <div class="inProductItem_btnRight" @click="changeTanStatus(true,item.contentid)">
                                            Images
                                        </div>
                                    </div>
                                </router-link>
                                <div class="inProductItem_word">
                                    <div class="titleBox">
                                        <div class="line"></div>
                                        <div class="name" ref="jlprotitle">{{item.title}}</div>
                                    </div>
                                    <div class="pagenavigation">
                                        <div class="fa fa-angle-up bannerSwiperLeft2" ></div>
                                        <div class="fa fa-angle-down bannerSwiperRight2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </swiper-slide>
            
          
            <!-- 底部 -->
            <swiper-slide class="inProduct_item footAuto">
                <Footer />
            </swiper-slide>

          </swiper>
		  <div class="mobileProductCover">
			  <BannerIn :bannerUrl="bannerUrl" :positionInfo="positionInfo" />
			  <NavIn :inNavInfo="inNavInfo"  />
			  <div class="inProduct_item" v-for="item in productList" :key="item.id">
			      <section class="inProductBox">
			          <div class="wrapper">
			              <div class="inProductItem">
			  
			                  <router-link to="#" class="inProductItem_img">
			                      <img :src="$root.$TEMP_URL+item.ico" />
			                      <div class="inProductItem_detail">
			                        <div class="title">{{item.title}}</div>
			                        <div class="line"></div>
			                        <div class="clear"></div>
			                        <div class="cen" v-html="item.content">
			   
			                        </div>
			                        
			                      </div>
			                      <div class="inProductItem_btnBox">
			                          <div class="inProductItem_btnLeft">
			                              <img src="./images/more_def.png" />
			                          </div>
			                          <div class="inProductItem_btnRight" @click="changeTanStatus(true,item.contentid)">
			                              Images
			                          </div>
			                      </div>
			                  </router-link>
			                  <div class="inProductItem_word">
			                      <div class="titleBox">
			                          <div class="line"></div>
			                          <div class="name">{{item.name}}</div>
			                      </div>
			                      <div class="pagenavigation">
			                          <div class="fa fa-angle-up bannerSwiperLeft2" ></div>
			                          <div class="fa fa-angle-down bannerSwiperRight2"></div>
			                      </div>
			                  </div>
			              </div>
			          </div>
			      </section>
			  </div>
			  <Footer />
		  </div>
		  
          </template>

          <template v-else>
                <BannerIn :bannerUrl="bannerUrl" :positionInfo="positionInfo" />
                <NavIn :inNavInfo="inNavInfo"  />
                      <section class="inProductBox">
                          <div class="wrapper">
                            <div class="inProNoData">
                                {{isZhong?'暂无数据':'No Data'}}
                            </div>
                          </div>
                      </section>      
                <Footer />

          </template>

          <div class="tan_proDetailBg" v-show="tanClicked">
              <div class="tan_proDetailTitle" v-if="tanPicsSingleArr.length">{{tanPicsSingleArr[0].title}}</div>
              <div class="tan_proDetailImgBox">
                 <div class="img" v-if="tanPics && tanPics.length>0" @click="changeTanStatus(false)">
                   <swiper :options="tanswiperOptionPlist" >
                     <swiper-slide class="tanimg_item" v-for="(item,index) in tanPics" :key="index">
                      <img :src="$root.$TEMP_URL+item" />
                     </swiper-slide>
                   </swiper>
                 </div>
                 <div class="btn">
                    <div class="close" @click="changeTanStatus(false)"><img src="./images/close_def.png" /></div>
                    <div class="tanSwiperRight right fa fa-angle-right"></div>
                    <div class="tanSwiperLeft left fa fa-angle-left"></div>

                 </div>
              </div>
          </div>


       
    </div>

  
  
</template>


<script>

import BannerIn from '../../../components/BannerIn/BannerIn'
import NavIn from '../../../components/NavIn/NavIn'
import Footer from '../../../components/Footer/Footer'

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import { getList,getSort,getNav } from '../../../api'
export default {
  components:{
      swiper,
      swiperSlide,
      BannerIn,
      NavIn,
      Footer
  },
  data(){
    var that = this;
    return{
        swiperOptionPlist: {
               loop: false,　　//是否自动轮播
　　　　　　　　autoplay: false,  //l轮播间隔时间
              direction: 'vertical',
　　　　　　　　navigation: {
                  nextEl: '.bannerSwiperRight2',
                  prevEl: '.bannerSwiperLeft2',
              },
              speed:1200,
              followFinger : false,
              mousewheel: true,
              slidesPerView: 'auto',
              on:{
                  slideChangeTransitionStart: function(){
                    // alert(this.activeIndex);
                    //让顶部滚动
                    if(this.activeIndex){
                      that.$parent.$parent.$refs.header.isScroll = true;
                    }else{
                      that.$parent.$parent.$refs.header.isScroll = false;
                    }
                  },
              },

    　　 },
        tanswiperOptionPlist: {
                loop: true,　　//是否循环轮播
  　　　　　　　　autoplay: false,  //l轮播间隔时间
  　　　　　　　　navigation: {
                    nextEl: '.tanSwiperRight',
                    prevEl: '.tanSwiperLeft',
                },
                speed:1000,
                followFinger : false,
                mousewheel: true,
                slidesPerView: 'auto',
            },
        
        bannerUrl:'' ,
        inNavInfo:[
            {
                title:'Automatic Baling Machine',
                url:'#',
                selected:true
            },
            {
                title:'Spraying Marking Machine',
                url:'#',
                selected:false
            },
            {
                title:'TEC Sensor',
                url:'#',
                selected:false
            }
        ],
        positionInfo:{
            second:'PRODUCTS',
            third:'Automatic Baling Machine'
        },
        productList:[],
        tanClicked:false,
        tanPics:[],
        isZhong:false,
        tanPicsSingleArr:[]

    }
  },
   created(){
      this.updateData();
      
  },
  mounted(){
      this.singleSetHeight();
      
  },
  // 监听,当路由发生变化的时候执行
    beforeRouteUpdate  (to, from, next) {
      this.updateData();
      
      let currentPath = to.path;
      let inNavInfo = this.inNavInfo;
      inNavInfo.forEach(v=>v.url==currentPath?v.selected=true:v.selected=false);
      this.inNavInfo= inNavInfo;
      this.$refs.proSwiper.swiper.slideTo(0)
      next();
    },
   beforeDestroy() {
      document.body.removeAttribute('style');
      document.querySelector('html').removeAttribute('style');
      document.querySelector("#app").removeAttribute('style');
      // document.querySelector(".footBox").removeAttribute('style');
      this.$root.$el.lastChild.removeAttribute('style');
      // document.querySelector('#app').removeAttribute('style');
  },
  methods:{
    changeTanStatus(status,contentid){
      const productList = this.productList;
      console.log(contentid)
      let tanPics = [];
      let defaultIco = '';
      if(contentid){
          let tanPicsSingleArr = productList.filter(v=>v.contentid==contentid);
          if(tanPicsSingleArr){
            this.tanPicsSingleArr = tanPicsSingleArr;
            
            let tanPicsString = tanPicsSingleArr[0].pics;
            console.log(tanPicsString)
            // defaultIco = tanPicsSingleArr[0].ico;
            if(tanPicsString){//如果有多图
               tanPics = tanPicsString.split(',');
            }
            // tanPics.unshift(defaultIco);
            this.tanPics = tanPics;
          }
      }
      //获取tanPics的数据并转换为数组
      // const selectedid = contentid; 
      //更新tanClicked状态，控制显示隐藏
      this.tanClicked = status;
      if(!status){
        this.tanPics = []
      }
    },
    async updateData(){
      const isZhong = this.$parent.isZhong;
      let resNav;
      let positionInfo = {};
      if(isZhong){
          resNav = await getNav(43);
          positionInfo={
              second:'产品中心',
              third:''
          }
      }else{
          resNav = await getNav(5);
          positionInfo={
              second:'PRODUCTS',
              third:''
          }
      }
      this.positionInfo = positionInfo;
      this.isZhong = isZhong;
      
      //二级分类
      let inNavInfo = resNav.data.map(v=>{
          return{
              title:v.name,
              url:'/products/productlist/'+v.scode,
              selected:false
          } 
      })
      inNavInfo.forEach(v=>v.url==this.$route.path?v.selected=true:v.selected=false);
      this.inNavInfo=inNavInfo;

      //更新产品列表
      const currentId = this.$route.params.id;
      const res = await getList(currentId);
      this.productList = res.data;
       //更新bannerIn
       const res2 = await getSort(5);
       this.bannerUrl = res2.data.pic;
       
    },
    singleSetHeight(){
      //单独设置满屏
      document.querySelector('body').setAttribute('style', 'height:100%');
      document.querySelector('html').setAttribute('style', 'height:100%');
      document.querySelector("#app").setAttribute('style', 'height:100%');
      // document.querySelector(".footBox").setAttribute('style', 'display:none');
      this.$root.$el.lastChild.setAttribute('style', 'display:none');
    }
        
  },
  watch:{
    
  }

}
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inProduct_list{
  height: 100%;
}
.inProductBox {
  .wrapper {
    .inProductItem {
       display: flex;
       align-items: center;
      .inProductItem_img {
        width: 1150px;
        display: block;
        position: relative;
        overflow: hidden;
        img {
            width: 100%;
            height: 647px;
            @include compatible(transition,all 0.8s) ;
        }
        .inProductItem_text{
          position:absolute;
          width: 100%;
          height: 100%;
          z-index: 2;
          left: 0;
          top: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 30px;
          font-weight: bold;
          color: #fff;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          @include compatible(transition,all 0.6s);
        }
        .inProductItem_detail{
          position:absolute;
          width: 46%;
          height: 69%;
          z-index: 2;
          right: 0;
          top: 0;
          padding: 68px 20px 32px 52px;
          // background: rgba(255, 255, 255, 0.8);
          opacity: 0;
          @include compatible(transition,all 0.6s);
          .title{
            line-height: 36px;
            color: $themeColor;
            text-align: right;
            font-size: 20px;
            text-shadow: #fff 2px 0 0, #fff 0 2px 0, #fff -1px 0 0, #fff 0 -1px 0;
          }
          .line{
            margin-top: 12px;
            width: 56px;
            height: 1px;
            // background: $themeColor;
            background: none;
            float: right;
          }
          .cen{
            margin-top: 30px;
            line-height: 30px;
            max-height: 300px;
            overflow: hidden;
            word-break: break-all;
          }

        }
        .inProductItem_btnBox {
          position:absolute;
          z-index: 3;
          left: 66px;
          bottom: 66px;
          display: flex;
          .inProductItem_btnLeft {
            width: 48px;
            background: rgba(0, 0, 0, 0.5);
            @include compatible(transition,all 0.6s);
            img {
              width: 100%;
              height: 48px;
            }
          }
          .inProductItem_btnRight {
            width: 116px;
            height: 48px;
            line-height: 48px;
            text-align: center;
            background: rgba(255, 255, 255, 0.7);
            @include compatible(transition,all 0.6s);
          }
          &:hover{
            .inProductItem_btnLeft{
              background: rgba(0, 0, 0, 1);
            }
            .inProductItem_btnRight{
              background: rgba(255, 255, 255, 1);
            }
          }
        }
       
      }
      &:hover{
        .inProductItem_img{
            .inProductItem_text{
              opacity: 1;
            }
            .inProductItem_detail{
              opacity: 1;
            }
            img{
              @include compatible(transform,scale(1.1)) ;
            }
        }
        .inProductItem_word{
           .titleBox{
              opacity: 0;
            }
        }
        
      }

      .inProductItem_word {
        width: 100px;
        height: 647px;
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .titleBox {
          width: 36px;
          display: flex;
          justify-content: space-between;
          padding-top: 28px;
          max-height: 455px;
          overflow: hidden;
          .line{
            width: 1px;
            height: 56px;
            background: $themeColor;
          }
          .name{
            font-size: 18px;
            font-weight: bold;
            color: $themeColor;
            width: 16px;
            white-space: nowrap;
            -webkit-writing-mode: vertical-rl;
            -ms-writing-mode: bt-rl;
            writing-mode: vertical-rl;
          }

        }
        .pagenavigation {
          margin-bottom:32px;
          height: 120px;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          justify-content: space-between;
          .fa {
            font-size: 46px;
            color: #787878;
            cursor: pointer;
            @include compatible(transition,all 0.6s) ;
            position: relative;
            top: 0;
            &:hover{
              color: $themeColor;
              top: -5px;
            }

          }
        }
      }
    }
  }
}

* {
  -webkit-box-sizing: border-box; /* Safari<=5 Android<=3 */
  -moz-box-sizing: border-box; /* <=28 */
  box-sizing: border-box;
}
/* Custom
 * --------------------------------------- */
html, body {
    height: 100%;
}

.swiper-wrapper{
    transition-delay:.3s;
  }
  .swiper-container {
      width: 100%;
      height: 100%;
      background: url(./images/beijing01_def.jpg) no-repeat;
      background-size: cover;
  }
  .swiper-slide {
      text-align: center;
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      height: 100%;
      
      &.headAuto{
        height: auto;
        flex-wrap: wrap;
        background: #fff;
      }
      &.footAuto{
        height: auto;
      }
  }
.swiper-slide:nth-child(2){
  color:#fff;}
.swiper-slide p{
  transform:translateX(-200px);
  opacity:0;
  transition:all .4s;}
.ani-slide p{
  transform:translateX(0);
  opacity:1;
}

.tan_proDetailBg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .tan_proDetailTitle {
    font-size: 28px;
    color: #fff;
    font-weight: bold;
  }

  .tan_proDetailImgBox {
    margin-top: 30px;
    display: flex;
    .img {
      width: 1150px;
      img {
        width: 100%;
        height: 647px;
      }
    }

    .btn {
      width: 100px;
      .fa,.close {
        width: 100%;
        height: 100px;
        background: #000;
        font-size: 60px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover{
          background: $themeColor;
        }
      }
      .left {
        border-top: 1px #3d3d3d solid;
      }
      .right {
        border-top: 1px #3d3d3d solid;
      }
      
    }
  }
}
.inProNoData{
    min-height: 298px;
    background: #fbfbfb;
    display: flex;
    justify-content: center;
    align-items: center;
}


</style>



// WEBPACK FOOTER //
// src/pages/Products/ProductList/ProductList.vue